import { render } from "./CalmRightSideSection.vue?vue&type=template&id=ebaaab92&scoped=true&ts=true"
import script from "./CalmRightSideSection.vue?vue&type=script&lang=ts"
export * from "./CalmRightSideSection.vue?vue&type=script&lang=ts"

import "./CalmRightSideSection.vue?vue&type=style&index=0&id=ebaaab92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebaaab92"]])

export default __exports__